import React from 'react';

import { IIconProps, TIconType } from '../interface';

const CrossIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='cross'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<path
				d='M11.2539 12L6 6.7494L6.74987 6L12 11.2469L17.2501 6L18 6.7494L12.7461 12L18 17.2506L17.2501 18L12 12.7531L6.74987 18L6 17.2506L11.2539 12Z'
				data-testid='cross-path'
				fill={props?.color || 'currentColor'}
			/>
		</svg>
	);
};

export default CrossIcon;
